import React from 'react';

const HTMLContainer = ({ type, children, ...props }) => {
	const Element = type || 'div';
	const paint_wrapper = props?.paint_wrapper ?? true;

	if(!paint_wrapper) {
		return children;
	}

	return (
		<Element {...props}>{children}</Element>
	)
};

export default HTMLContainer;